import axios from "axios";
import { executeApiRequest } from "@/plumbing/http/apiClient";
import notificationStore from "@/store/notificationStore";

export type CreateVideoRequestRequest = {
  collectionEventId: number;
  isCollectionIssue: boolean;
};

export type CreateVideoRequestResponse = {};

export const createVideoRequest = async (request: CreateVideoRequestRequest) => {
  try {
    await executeApiRequest(async () => {
      return await axios.post(`/videorequests`, request);
    }, false);
  } catch (error) {
    if (error.response.status === 400 && error.response.data.title === "No video requests remain this week") {
      notificationStore.error("You have no video requests remaining this week. Please contact support to resolve this issue.");
    } else {
      notificationStore.error("An unexpected error submitting the video request");
    }
    return false;
  }
  return true;
};
